module.exports = __webpack_public_path__ + "img/LaPerla106-Panorama.0b2ccec0.jpg";